import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { hexContrast } from '@/lib/color'
import { random } from '@/lib/api'
import type { RegistryColor } from '@/lib/registry'

/**
 * One registered color, its name,
 * and the CM mark, filling a 200px band. Links to the color's page.
 */
export default function RandomColorCard({ className = '' }: { className?: string }) {
  const [color, setColor] = useState<RegistryColor | null>(null)

  useEffect(() => {
    let alive = true
    random(1).then((c) => {
      if (alive && c[0]) setColor(c[0])
    })
    return () => {
      alive = false
    }
  }, [])

  const bg = color?.hex ?? '#e5e5e5'
  const text = hexContrast(bg)
  return (
    <div
      className={`flex min-h-[200px] w-full items-center justify-center px-4 text-center font-display transition-colors duration-500 ${className}`}
      style={{ backgroundColor: bg, color: text }}
      aria-busy={!color}
    >
      {color && (
        <h4 className="m-0 text-[clamp(1.5rem,2.2vw,2.4rem)]">
          <Link to={`/color/${color.slug}`} className="no-underline hover:underline" style={{ color: text }}>
            {color.name}
          </Link>
          <sup className="align-[1.6em]">CM</sup>
        </h4>
      )}
    </div>
  )
}
